// Maydon (field) rollari o'zining soddalashtirilgan sahifasiga tushadi.
export function landingPath(user) {
  if (user?.isSnabjenist) return '/snab';          // ta'minotchi → zayavkalar
  if (user?.isProcessWorker) return '/process';    // jarayon xodimi → jarayonlar
  if (user?.isSalesAgent) return '/sales-agent';   // sotuv agenti → mobil sotuv
  if (user?.isWarehouseManager) return '/warehouse-manager'; // ombor mudiri → fakturalar statusi
  if (user?.isCourier) return '/courier';           // kuryer → yetkazish statusi
  if (user?.isDebtCollector) return '/debt-collector'; // qarz yig'uvchi → biriktirilgan qarzdorlar
  return '/m/dashboard';
}

// Shu rollardagi xodimlar to'liq admin sidebar'ini ko'rmaydi — ularga soddalashtirilgan ko'rinish beriladi.
export const isFieldRoleUser = (user) => landingPath(user) !== '/m/dashboard';
